import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'

import TimePicker from 'material-ui/TimePicker';
import FlatButton from 'material-ui/FlatButton';
import TextField from 'material-ui/TextField';
import Dialog from 'material-ui/Dialog';

import moment from 'moment-timezone'

import {closeAddSessionForm, updateSessionField, updateSession, displayError} from '../../actions/sessions'

class AddSession extends Component {

  static defaultProps = {
  }

  static propTypes = {
    dispatch: PropTypes.func.isRequired
  }

  componentDidMount() {
  }

  closeDialog() {
    const { dispatch } = this.props
    dispatch(closeAddSessionForm())
  }

  updateSession() {
    const { dispatch } = this.props

    let session = this.props.session
    let sessionTime = moment(session.startDateTime)

    let event = this.props.event
    let eventDate = moment(event.eventDate)

    let newSessionTime = moment().tz('America/New_York')

    newSessionTime.year(eventDate.year())
    newSessionTime.month(eventDate.month())
    newSessionTime.date(eventDate.date())
    newSessionTime.hour(sessionTime.hour())
    newSessionTime.minute(sessionTime.minute())

    this.props.session.startDateTime = newSessionTime

		if (this.props.session.duration != null && this.props.session.duration.toString().match(/[a-z]/i)) {
      return dispatch(displayError("Duration must be a numeric value!"))
    }

    dispatch(updateSession(this.props.session))
  }

  updateSessionField(name, event, date) {
    const { dispatch } = this.props
    dispatch(updateSessionField(name, date))
  }

  render() {

    if (this.props.session) {
      const actions = [
        <FlatButton
          label="Cancel"
          primary={true}
          onClick={this.closeDialog.bind(this)}
        />,
        <FlatButton
          label={this.props.session._id == null ? "Add Session" : "Update Session"}
          primary={true}
          onClick={this.updateSession.bind(this)}
        />,
      ];

      return (<Dialog
        actions={actions}
        title="Add Session"
        modal={true}
        open={this.props.session != null}>
          <TimePicker
            name="startDateTime"
            format="ampm"
            hintText="Start Time"
            value={moment(this.props.session.startDateTime).toDate()}
            onChange={this.updateSessionField.bind(this, 'startDateTime')}
          />
          <TextField
                name="duration"
                floatingLabelText="Duration"
                value={this.props.session.duration}
                floatingLabelFixed={true}
                onChange={this.updateSessionField.bind(this, 'duration')}
              />

						<div style={{color: "red"}}>{this.props.sessionError}</div>
      </Dialog>)
    } else {
      return (<div />)
    }
  }
}

const mapStateToProps = state => {
  return state.eventsReducer
}

export default withRouter(
  connect(mapStateToProps)(AddSession)
);



// WEBPACK FOOTER //
// ./src/components/sessions/AddSession.js